import React from 'react';
const Overlay = ({ bi }) => {
    return (
        <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: 'rgba(0, 0, 0, 0.54)' }} />
    );
}

export default Overlay;
//


// WEBPACK FOOTER //
// ./src/components/partials/black_overlay.js